<template>
	<v-card-text>
		<v-row v-if="step.substeps">
			<substeps :substeps="step.substeps" />
		</v-row>
		<v-row v-else>
			<step :step="step" />
		</v-row>
		<v-row v-if="!unpairing && !success" class="mt-5">
			<v-col cols="8" sm="9"
				>If you need to unpair the device first, click "Unpair"</v-col
			>
			<v-col cols="4" sm="3">
				<v-btn text color="primary" @click="doUnpair">Unpair</v-btn>
			</v-col>
		</v-row>
		<v-row v-else-if="success" class="mt-5">
			<v-col cols="8" sm="9"
				>Device is now unpaired! Click next to continue...</v-col
			>
		</v-row>
		<v-row v-else class="mt-5">
			<v-progress-linear indeterminate />
			<v-col cols="8" sm="9">
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-html="unpairText" />
			</v-col>
			<v-col cols="4" sm="3">
				<v-btn text color="error" @click="cancel">Cancel</v-btn>
			</v-col>
		</v-row>
	</v-card-text>
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";

import Substeps from "../Substeps";
import Step from "../Step";

import stepBase from "../../extends/step";
import zwaveBase from "../../extends/zwave";

export default {
	components: {
		Substeps,
		Step,
	},

	mixins: [stepBase, zwaveBase],

	props: {
		step: Object,
		unpair: Object,
	},

	data() {
		return {
			success: false,
			unpairing: false,
			stepNumber: 1,
		};
	},

	computed: {
		unpairText() {
			const customMessage = _.get(this, "unpair.text");
			const defaultMessage =
				"Waiting to unpair. Follow your devices instructions to finish removing from network...";
			return customMessage || defaultMessage;
		},
	},

	methods: {
		...mapActions({ setNodeProperty: "controller/nodes/setProperty" }),

		// Required by zwaveBase
		start() {},

		cancel() {
			this.$log(`ZWave Wizard: Unpairing cancelled`);
			this.unpairing = false;
			this.stop();
		},

		async doUnpair() {
			if (this.busy) {
				return;
			}
			this.setBusy(true);

			let bridge = await this.getBridge();

			let response;

			try {
				this.unpairing = true;

				this.$log(`ZWave Wizard: Starting unpair ${this.device.path}`);

				response = await bridge.child("commands/removeNode").execute();
				this.unpairing = false;
			} catch (e) {
				if (!this.unpairing || !this.busy) {
					// cancelled
					return;
				}

				this.unpairing = false;

				return this.showError("Unpair failed. Please try again.");
			}

			if (response.status === "Node removed.") {
				await this.setNodeProperty({
					nodeGuid: this.device.meta ? this.device.meta.guid : this.device.guid,
					propName: "networkId",
					propValue: null,
				});
				this.success = true;
				this.$log(`ZWave Wizard: Device unpaired ${this.device.path}`);
			} else {
				return this.showError("Unpair failed. Please try again.");
			}

			this.setBusy(false);
		},
	},
};
</script>
